export default "__VITE_ASSET__CCBP11va__"